import { FCWithChildren } from '@types';
import React from 'react';

const ModalBody: FCWithChildren = ({ children }) => (
  <div className="relative p-6 flex-auto">{children}</div>
);

export default ModalBody;
